module.exports = __webpack_public_path__ + "static/adrienjoly-c2dc8b26c5e97fa78c484b82202ad848.png";